import { authServiceAxiosClient } from '@/lib';
import { PaginatedApiResponse, PaginatedData } from '@/types';
import { withLogger } from '@/utils';

import { userSettingsAPIUrls } from '../data';
import { User } from '../types';

type Param = {
  searchString: string;
  page: number;
  rowsPerPage: number;
};

type Users = Array<User>;
type Return = PaginatedData<Users>;

export type GetAdminUsers = {
  param: Param;
  return: Return;
};

export const getUsers = withLogger(
  async ({
    searchString: search,
    page,
    rowsPerPage: per_page,
  }: Param): Promise<Return> => {
    const {
      data: { data },
    } = await authServiceAxiosClient.get<PaginatedApiResponse<Users>>(
      userSettingsAPIUrls.getUsers,
      {
        params: {
          search,
          page,
          per_page,
        },
      },
    );
    return data;
  },
);
